import React from 'react';
import './styles/home.css';

const Footer = () => {
  return (
    <div>
      <footer>
                <p>Emmerson Web Design, Copyright &copy; 2023</p>
            </footer>

    </div>
  )
}

export default Footer
